import * as actionTypes from "../constants";
import * as apis from "../requests/apis";
import * as getPayload from "../requests/payloads";
import { clientRequest } from "../requests";
import { showToast } from "utils/toast";
import { TOAST_TYPE } from "utils/toast";

// Get Profile
// CustomerUi controller is gone on dementia — the old two-call
// (GetUserName + GetOrganisation) approach is replaced by a single
// Profile/GetMyProfile call returning a ProfileDto.
export const getProfile = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_PROFILE });

    const res = await clientRequest(actionTypes.GET, apis.GET_MY_PROFILE_API);
    const payload = getPayload.getProfile(res.data);
    dispatch({
      type: actionTypes.GET_PROFILE_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_PROFILE_FAIL,
      payload: err,
    });
  }
};

//Get profile by id
export const getProfileById = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_USERINFO });
    const userInfo = await clientRequest(actionTypes.POST, apis.GET_PROFILE_BY_ID_API, { Email: email })
    dispatch({
      type: actionTypes.GET_USERINFO_SUCCESS,
      payload: userInfo.data[0]
    })
  } catch (error) {
    dispatch({
      type: actionTypes.GET_USERINFO_FAIL,
      payload: error
    })
  }
}

//save profile
export const saveUserProfile = (info) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.UPDATE_USERINFO })
    const updateInfo = await clientRequest(actionTypes.POST, apis.UPDATE_USERINFO_API, info)
    dispatch({
      type: actionTypes.UPDATE_USERINFO_SUCCESS,
      payload: updateInfo.data
    })
    showToast("Profile updated successfully.", TOAST_TYPE.success)
  } catch (error) {
    showToast("Failed to update profile. Please try again.", TOAST_TYPE.error)
    dispatch({
      type: actionTypes.UPDATE_USERINFO_FAIL,
      payload: error
    })
  }
}

// No Profile/GetProfiles equivalent found on dementia, but this action has
// no live callers in the current app either — left as-is, will 404 if ever
// called, same as the other genuinely-unimplemented placeholders.
export const getProfiles = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_PROFILES });
    const profiles = await clientRequest(actionTypes.GET, apis.GET_PROFILES_API);
    const payload = getPayload.getProfiles(profiles.data);
    dispatch({
      type: actionTypes.GET_PROFILES_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_PROFILES_FAIL,
      payload: err,
    });
  }
};

// OtherProfile controller is gone entirely on dementia — no replacement
// found. Will 404 until/unless the backend adds something equivalent.
export const getOtherProfiles = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_OTHER_PROFILES });
    const otherProfiles = await clientRequest(actionTypes.GET, apis.GET_OTHER_PROFILES_API);
    const payload = getPayload.getOtherProfiles(otherProfiles.data);
    dispatch({
      type: actionTypes.GET_OTHER_PROFILES_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_OTHER_PROFILES_FAIL,
      payload: err,
    });
  }
};

export const getAccounts = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ACCOUNTS });
    const accounts = await clientRequest(actionTypes.GET, apis.GET_ACCOUNTS_API);
    const payload = getPayload.getAccounts(accounts.data);
    dispatch({
      type: actionTypes.GET_ACCOUNTS_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_ACCOUNTS_FAIL,
      payload: err,
    });
  }
};

// Org/GetDoctors and Org/GetPatients are POST (unchanged). Org/GetOrgs is a
// parameterless GET on dementia — the old {Email} filter body is dropped;
// the backend scopes results to the caller automatically.
export const getAllProfiles = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ALL_PROFILES });
    const doctors = await clientRequest(actionTypes.POST, apis.GET_DOCTORS_API, { Email: email || null });
    const patients = await clientRequest(actionTypes.POST, apis.GET_PATIENTS_API, { Email: email || null });
    const feedbacks = await clientRequest(actionTypes.POST, apis.GET_FEEDBACKS_API, { Email: email || null });
    const orgs = await clientRequest(actionTypes.GET, apis.GET_ORGS_API);
    const payload = getPayload.getAllProfiles(orgs, doctors, patients, feedbacks);
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_FAIL,
      payload: err,
    });
  }
};
export const getAllDoctors = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GET_All_DOCTORS });
    const doctors = await clientRequest(actionTypes.POST, apis.GET_DOCTORS_API, { Email: email || null });
    const payload = doctors.data
    dispatch({
      type: actionTypes.GET_All_DOCTORS_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_All_DOCTORS_FAIL,
      payload: err,
    });
  }
};
export const getAllPatients = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GET_All_PATIENTS });
    const patients = await clientRequest(actionTypes.POST, apis.GET_PATIENTS_API, { Email: email || null });
    const payload = patients.data
    dispatch({
      type: actionTypes.GET_All_PATIENTS_SUCCESS,
      payload,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_All_PATIENTS_FAIL,
      payload: err,
    });
  }
};

export const getOrgDoctors = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ALL_PROFILES });
    const doctors = await clientRequest(actionTypes.POST, apis.GET_ORG_DOCTOR_API, { Email: email || null });
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_SUCCESS,
      payload: { doctors: doctors.data, patients: [], orgs: [], feedbacks: [] },
    });
  } catch (err) {
    dispatch({ type: actionTypes.GET_ALL_PROFILES_FAIL, payload: err });
  }
}
export const getPatients = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ALL_PROFILES });
    const patients = await clientRequest(actionTypes.POST, apis.GET_PATIENTS_API, { Email: email || null });
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_SUCCESS,
      payload: { patients: patients.data, doctors: [], orgs: [], feedbacks: [] },
    });
  } catch (err) {
    dispatch({ type: actionTypes.GET_ALL_PROFILES_FAIL, payload: err });
  }
}
export const getFeedBack = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ALL_PROFILES });
    const feedbacks = await clientRequest(actionTypes.GET, apis.GET_FEEDBACKS_API);
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_SUCCESS,
      payload: { feedbacks: feedbacks.data, patients: [], doctors: [], orgs: [] },
    });
  } catch (err) {
    dispatch({ type: actionTypes.GET_ALL_PROFILES_FAIL, payload: err });
  }
}
// Org/GetOrgs (via GET_ORG_LIST_API) is a parameterless GET — email filter dropped.
export const getOrgs = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_ALL_PROFILES });
    const orgs = await clientRequest(actionTypes.GET, apis.GET_ORG_LIST_API);
    dispatch({
      type: actionTypes.GET_ALL_PROFILES_SUCCESS,
      payload: { orgs: Array.isArray(orgs.data) ? orgs.data : [orgs.data].filter(Boolean), patients: [], doctors: [], feedbacks: [] },
    });
  } catch (err) {
    dispatch({ type: actionTypes.GET_ALL_PROFILES_FAIL, payload: err });
  }
}
export const getAllProfilesById = (email, role) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GET_PROFILES_BY_ID });
    const allProfiles = await clientRequest(actionTypes.POST, apis.GET_PROFILES_BY_ID_API, { Email: email || null, Name: role || null });
    dispatch({
      type: actionTypes.GET_PROFILES_BY_ID_SUCCESS,
      payload: allProfiles?.data,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_PROFILES_BY_ID_FAIL,
      payload: err,
    });
  }
}

// These three used to hit each resource's own list endpoint with a Name
// filter, but Org/GetDoctors, Org/GetPatients and Org/GetOrgs don't accept
// search params on dementia — redirected to the shared Search/AdvancedSearch
// endpoint instead, same pattern already used by family/event/item/etc.
export const advanceSearch_getOrgDoctor = (name) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.ADVANCE_SEARCH });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${name}&searchType=doctor`);
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_SUCCESS,
      payload: {
        orgs: [],
        doctors: res.data,
        patients: [],
        feedbacks: []
      },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_FAIL,
      payload: err,
    });
  }
}

export const advanceSearch_getPatient = (name) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.ADVANCE_SEARCH });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${name}&searchType=patient`);
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_SUCCESS,
      payload: {
        orgs: [],
        doctors: [],
        patients: res.data,
        feedbacks: []
      },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_FAIL,
      payload: err,
    });
  }
}

export const advanceSearch_getProfilesById = (name) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.ADVANCE_SEARCH });
    const profiles = await clientRequest(actionTypes.POST, apis.GET_PROFILES_BY_ID_API, { Name: name || null });
    dispatch({
      type: actionTypes.GET_PROFILES_BY_ID_SUCCESS,
      payload: profiles.data
    });
  } catch (err) {
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_FAIL,
      payload: err,
    });
  }
}

export const advanceSearch_getOrs = (name) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.ADVANCE_SEARCH });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${name}&searchType=org`);
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_SUCCESS,
      payload: {
        orgs: res.data,
        doctors: [],
        patients: [],
        feedbacks: []
      },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.ADVANCE_SEARCH_FAIL,
      payload: err,
    });
  }
}

//change password
export const changePassword = ({ Email, OldPassword, NewPassword }) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.CHANGE_PASSWORD })
    const info = await clientRequest(actionTypes.POST, apis.CHANGE_PASSWORD_API, { Email, OldPassword, NewPassword })
    dispatch({
      type: actionTypes.CHANGE_PASSWORD_SUCCESS,
      payload: info
    })
  } catch (error) {
    dispatch({
      type: actionTypes.CHANGE_PASSWORD_FAIL,
      payload: error
    })
  }
}

//bug report
export const submitBugReport = ({ subject, message, userId }) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.NEW_FEEDBACK })
    const submitBug = await clientRequest(actionTypes.POST, apis.ADD_FEEDBACK_API, {
      subject,
      message,
      userId,
      dateReported: new Date().toISOString(),
      dateReportUlpoaded: new Date().toISOString(),
    })
    dispatch({
      type: actionTypes.NEW_FEEDBACK_SUCCESS,
      payload: submitBug
    })
  } catch (error) {
    dispatch({
      type: actionTypes.NEW_FEEDBACK_FAIL,
      payload: error
    })
  }
}

export const deleteAccount = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.DELETE_ACCOUNT_REQUEST });
    await clientRequest(actionTypes.POST, apis.DELETE_ACCOUNT_API, { Email: email || "" });
    dispatch({
      type: actionTypes.DELETE_ACCOUNT_SUCCESS,
      payload: null,
    });
    showToast("Profile deleted successfully.", TOAST_TYPE.success);
  } catch (err) {
    dispatch({
      type: actionTypes.DELETE_ACCOUNT_FAIL,
      payload: err,
    });
  }
};
